import { render } from "./CrewBio.vue?vue&type=template&id=53cc5778"
import script from "./CrewBio.vue?vue&type=script&lang=js"
export * from "./CrewBio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__